import TomSelect from 'tom-select';

export function initSelects(sortOptions = []) {
	const selectElements = document.querySelectorAll('.select:not(.custom-initialized)');

	selectElements.forEach((selectWrapper) => {
		let select = selectWrapper.querySelector('.select__el');
		const labelText = select.getAttribute('aria-label') || select.closest('.select')?.getAttribute('data-select-label') || 'Оберіть значення';
		if (select) {
			new TomSelect(select, {
				// Disable text input so the control behaves like a native dropdown
				create: false,
				controlInput: null,
				searchField: [],
				sortField: sortOptions,
				onInitialize() {
					const control = this.control;
					const dropdown = this.dropdown_content || this.dropdown;
			
					select.setAttribute('aria-label', labelText);
			
					if (control) {
						control.setAttribute('aria-label', labelText);
					}
			
					if (dropdown) {
						dropdown.setAttribute('aria-label', labelText);
					}
				}
			});
		}
	});
}
